import { render } from "./QuizGroupDetail.vue?vue&type=template&id=8ef049bc"
import script from "./QuizGroupDetail.vue?vue&type=script&lang=js"
export * from "./QuizGroupDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__